export default "__VITE_ASSET__SNrZcE1R__"